import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function DogIdentifierPage() {
  return (
    <div style={{ backgroundColor: '#0f0f0f', minHeight: '100vh', color: '#fff' }}>

      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #0f0f0f 100%)', padding: '80px 0 60px' }}>
        <Container>
          <Row className="align-items-center justify-content-center text-center">
            <Col md={8}>
              <div style={{
                width: 100, height: 100,
                borderRadius: 24,
                background: 'linear-gradient(135deg, #E8855A, #c96a3e)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 50, margin: '0 auto 28px',
                boxShadow: '0 0 40px rgba(232,133,90,0.35)',
              }}>
                🐾
              </div>
              <h1 style={{ fontSize: 42, fontWeight: 800, letterSpacing: -0.5, marginBottom: 12 }}>
                Dog Identifier
              </h1>
              <p style={{ fontSize: 18, color: '#a0a0a0', marginBottom: 8 }}>
                AI-Powered Breed Recognition
              </p>
              <span style={{
                display: 'inline-block',
                background: 'rgba(232,133,90,0.15)',
                border: '1px solid rgba(232,133,90,0.4)',
                color: '#E8855A',
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: 2,
                padding: '3px 10px',
                borderRadius: 6,
                marginBottom: 36,
              }}>
                AI POWERED
              </span>

              <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 40 }}>
                <a
                  href="https://apps.apple.com/app/dog-identifier-breed-scanner/id6746899498"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    background: '#fff',
                    color: '#000',
                    padding: '12px 28px',
                    borderRadius: 12,
                    fontWeight: 700,
                    textDecoration: 'none',
                    fontSize: 15,
                  }}
                >
                  🍎 Download on App Store
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.dogidentifier.app"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    background: '#E8855A',
                    color: '#fff',
                    padding: '12px 28px',
                    borderRadius: 12,
                    fontWeight: 700,
                    textDecoration: 'none',
                    fontSize: 15,
                  }}
                >
                  🤖 Get it on Google Play
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features */}
      <section style={{ padding: '60px 0', background: '#141414' }}>
        <Container>
          <h2 className="text-center" style={{ fontWeight: 700, marginBottom: 40 }}>What Dog Identifier Does</h2>
          <Row className="g-4">
            {[
              { icon: '📷', title: 'Instant Breed Scan', desc: 'Point your camera at any dog and identify its breed in seconds using AI.' },
              { icon: '📚', title: '500+ Breed Profiles', desc: 'Access detailed profiles including traits, history, and care tips for 500+ breeds.' },
              { icon: '❤️', title: 'Save Favorites', desc: 'Bookmark your favourite breeds and build your personal dog encyclopedia.' },
              { icon: '💡', title: 'Daily Dog Facts', desc: 'Get fun, curated dog facts and training tips delivered every day.' },
            ].map((f, i) => (
              <Col md={6} lg={3} key={i}>
                <div style={{
                  background: '#1e1e1e',
                  border: '1px solid rgba(232,133,90,0.15)',
                  borderRadius: 16,
                  padding: 24,
                  height: '100%',
                }}>
                  <div style={{ fontSize: 36, marginBottom: 12 }}>{f.icon}</div>
                  <h5 style={{ fontWeight: 700, marginBottom: 8 }}>{f.title}</h5>
                  <p style={{ color: '#888', fontSize: 14, margin: 0 }}>{f.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Legal links */}
      <section style={{ padding: '48px 0', background: '#0f0f0f' }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h4 style={{ fontWeight: 700, marginBottom: 8 }}>Legal</h4>
              <p style={{ color: '#888', marginBottom: 24 }}>
                By using Dog Identifier, you agree to the following policies.
              </p>
              <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link
                  to="/dog-identifier/privacy-policy"
                  style={{
                    background: 'rgba(232,133,90,0.12)',
                    border: '1px solid rgba(232,133,90,0.35)',
                    color: '#E8855A',
                    padding: '10px 24px',
                    borderRadius: 10,
                    fontWeight: 600,
                    textDecoration: 'none',
                    fontSize: 15,
                  }}
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/dog-identifier/terms"
                  style={{
                    background: 'rgba(232,133,90,0.12)',
                    border: '1px solid rgba(232,133,90,0.35)',
                    color: '#E8855A',
                    padding: '10px 24px',
                    borderRadius: 10,
                    fontWeight: 600,
                    textDecoration: 'none',
                    fontSize: 15,
                  }}
                >
                  Terms &amp; Conditions
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <div style={{ background: '#0a0a0a', padding: '24px 0', textAlign: 'center' }}>
        <p style={{ color: '#555', margin: 0, fontSize: 13 }}>
          &copy; {new Date().getFullYear()} Dog Identifier by{' '}
          <a href="/" style={{ color: '#E8855A', textDecoration: 'none' }}>Westron</a>.
          All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default DogIdentifierPage;
